import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { GAMES, CATEGORY_ORDER, FAMILY } from "@/lib/games";

export default function AllResults() {
  const grouped = CATEGORY_ORDER.map((cat) => ({ cat, items: GAMES.filter((g) => g.category === cat) }));
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <SEO title="All Teer Results | 21 Live Teer Result Pages | Juwai Teer" description="Browse all 21 Teer result pages — Juwai, Shillong, Morning, Night and other Teer — with results, previous results and common numbers." path="/all-results" />
      <Header />
      <section className="border-b border-neutral-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 py-8">
          <h1 className="font-heading font-black tracking-tight text-2xl sm:text-4xl">All Teer Results</h1>
          <p className="mt-2 text-sm text-neutral-600">Direct links to result, previous results and common number pages.</p>
        </div>
      </section>
      <main className="flex-1 max-w-5xl w-full mx-auto px-4 py-6">
        {grouped.map((gr) => (
          <section key={gr.cat} className="mb-8">
            <h2 className="font-heading text-lg sm:text-xl font-bold mb-3">{gr.cat}</h2>
            <div className="grid sm:grid-cols-2 gap-3">
              {gr.items.map((g) => {
                const f = FAMILY[g.color_family];
                return (
                  <div key={g.slug} className={`bg-white rounded-xl border-2 ${f.border} p-4`}>
                    <div className="flex items-center justify-between">
                      <div>
                        <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-bold">#{String(g.number).padStart(2, "0")}</div>
                        <div className="font-heading font-bold text-lg mt-0.5">{g.name}</div>
                      </div>
                    </div>
                    <div className="mt-3 grid grid-cols-3 gap-2 text-center text-xs font-semibold">
                      <Link to={`/${g.slug}`} className={`py-2 rounded-md ${f.head} hover:opacity-90`}>Result</Link>
                      <Link to={`/${g.slug}/previous-result`} className="py-2 rounded-md border border-neutral-300 hover:bg-neutral-50">Previous</Link>
                      <Link to={`/${g.slug}/common-number`} className="py-2 rounded-md border border-neutral-300 hover:bg-neutral-50">Common</Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </main>
      <Footer />
    </div>
  );
}
